import {Component, Input, OnInit} from '@angular/core';
import {ContractInfo, Format, ProjectService} from "@app/shared";
import {plainToClass} from "class-transformer";

@Component({
  selector: 'app-contract-info',
  templateUrl: './contract-info.component.html',
  styleUrls: ['./contract-info.component.css']
})
export class ContractInfoComponent implements OnInit {

  Format: typeof Format = Format;

  @Input()
  contractId: number;

  @Input()
  orgIds: number[];

  contractInfo: ContractInfo;

  constructor(private projectService: ProjectService) {
  }

  ngOnInit(): void {
  }

  onClickShowContractInfo(op, event): void {
    this.projectService.getContractInfoById(this.contractId, null, this.orgIds).subscribe(res => {
      this.contractInfo = plainToClass(ContractInfo, res);
      op.toggle(event);
    });
  }
}
